// extracted by mini-css-extract-plugin
export default {"chatCurrent":"ChatCurrent_chatCurrent__b2Aaq","wrap":"ChatCurrent_wrap__pg0TY"};